import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";

export class FinalSalaryOptionInfoStatic {
    public type: FinalSalaryOption;
    public name: string;
    public abbreviation: string;
    public crossoverAgeRelevant: boolean;
    public icon: string;
    public description: Array<string>;

    constructor(type: FinalSalaryOption, name: string, abbreviation: string, crossoverAgeRelevant: boolean, icon: string) {
        this.type = type;
        this.name = name;
        this.abbreviation = abbreviation;
        this.crossoverAgeRelevant = crossoverAgeRelevant;
        this.icon = icon;
        this.description = [];
    }

    public getFullName() {
        return this.abbreviation ? `${this.name} (${this.abbreviation})` : this.name;
    }
}

const standard: FinalSalaryOptionInfoStatic = new FinalSalaryOptionInfoStatic(
    FinalSalaryOption.SchemeDefault,
    "Standard Pension Option",
    "",
    false,
    "bi-cash-stack"
);

const pensionIncreaseExchange: FinalSalaryOptionInfoStatic = new FinalSalaryOptionInfoStatic(
    FinalSalaryOption.PensionIncreaseExchange,
    "Pension Increase Exchange",
    "PIE",
    true,
    "bi-wallet"
);

const bridgingPension: FinalSalaryOptionInfoStatic = new FinalSalaryOptionInfoStatic(
    FinalSalaryOption.BridgingPension,
    "Bridging Pension Option",
    "BP",
    false,
    "bi-backpack"
);

class FinalSalaryOptionsStatic {
    public standard: FinalSalaryOptionInfoStatic;
    public pensionIncreaseExchange: FinalSalaryOptionInfoStatic;
    public bridgingPension: FinalSalaryOptionInfoStatic;

    constructor(standard: FinalSalaryOptionInfoStatic, pensionIncreaseExchange: FinalSalaryOptionInfoStatic, bridgingPension: FinalSalaryOptionInfoStatic) {
        this.standard = standard;
        this.pensionIncreaseExchange = pensionIncreaseExchange;
        this.bridgingPension = bridgingPension;
    }

    public getAllOptions(): FinalSalaryOptionInfoStatic[] {
        return [
            this.standard,
            this.pensionIncreaseExchange,
            this.bridgingPension
        ];
    }

    public get(option: FinalSalaryOption): FinalSalaryOptionInfoStatic {
        const finalSalaryOption: FinalSalaryOptionInfoStatic | undefined = this.getAllOptions().find(fsoi => fsoi.type == option);

        if (!finalSalaryOption) {
            throw new Error(`Missing option: ${option}`);
        }

        return finalSalaryOption;
    }

    public optionFromString(value: string): FinalSalaryOption | undefined {
        if (!value) {
            return FinalSalaryOption.SchemeDefault;
        }

        if (value == this.standard.name) {
            return FinalSalaryOption.SchemeDefault;
        } else if (value == this.pensionIncreaseExchange.name) {
            return FinalSalaryOption.PensionIncreaseExchange;
        } else if (value == this.bridgingPension.name) {
            return FinalSalaryOption.BridgingPension;
        }

        throw new Error("Unknown option.");
    }
}

export { FinalSalaryOptionsStatic };
export { standard, pensionIncreaseExchange, bridgingPension }
